import styled from "styled-components";

export const ContactSectionWrapper = styled.div.attrs({
  className: "bg-gray-400 py-12 px-4",
})``;

export const ContactContainer = styled.div.attrs({
  className:
    "flex flex-col md:flex-row justify-between items-center max-w-6xl mx-auto",
})``;

export const LogoContainer = styled.div.attrs({
  className:
    "bg-white shadow-md p-6 rounded-lg text-center mx-4",
})``;

export const LogoText = styled.h2.attrs({
  className: "text-3xl font-bold text-gray-800",
})``;

export const ContactInfo = styled.div.attrs({
  className: "text-center md:text-left space-y-4 mx-4",
})``;

export const ContactInfoHeading = styled.p.attrs({
  className: "text-lg font-semibold text-gray-800",
})``;

export const ContactInfoDetails = styled.p.attrs({
  className: "text-black",
})``;

export const ContactInfoLink = styled.a.attrs({
  className: "text-black hover:underline",
})``;

export const CreditsSection = styled.div.attrs({
  className: "mt-6 text-center",
})``;

export const CreditsText = styled.p.attrs({
  className: "text-sm text-gray-700",
})``;

export const CreditsLink = styled.a.attrs({
  className: "text-blue-500 hover:text-blue-700",
})``;
